import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import { recordVisit } from "@/api";
import { applySEOPage } from "@/composables/useSEO";

const AdminLayout = () => import("../layouts/AdminLayout.vue");

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: { title: "首页 - 鑫品钢结构" },
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import("../views/Projects.vue"),
    meta: { title: "工程案例 - 鑫品钢结构" },
  },
  {
    path: "/projects/:id",
    name: "ProjectDetail",
    component: () => import("../views/ProjectDetail.vue"),
    meta: { title: "案例详情 - 鑫品钢结构" },
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue"),
    meta: { title: "新闻中心 - 鑫品钢结构" },
  },
  {
    path: "/news/:id",
    name: "NewsDetail",
    component: () => import("../views/NewsDetail.vue"),
    meta: { title: "新闻详情 - 鑫品钢结构" },
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
    meta: { title: "关于我们 - 鑫品钢结构" },
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: () => import("../views/Jobs.vue"),
    meta: { title: "人才招聘 - 鑫品钢结构" },
  },
  {
    path: "/jobs/:id",
    name: "JobDetail",
    component: () => import("../views/JobDetail.vue"),
    meta: { title: "职位详情 - 鑫品钢结构" },
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
    meta: { title: "联系我们 - 鑫品钢结构" },
  },

  /* ---- Admin routes ---- */
  {
    path: "/admin/login",
    name: "AdminLogin",
    component: () => import("../views/admin/Login.vue"),
    meta: { title: "后台登录 - 鑫品钢结构" },
  },
  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "AdminDashboard",
        component: () => import("../views/admin/Dashboard.vue"),
        meta: {
          adminTitle: "仪表盘",
          title: "后台管理 - 鑫品钢结构",
          permission: "dashboard:view",
        },
      },
      {
        path: "news",
        name: "AdminNewsList",
        component: () => import("../views/admin/NewsList.vue"),
        meta: {
          adminTitle: "新闻管理",
          title: "新闻管理 - 鑫品钢结构",
          permission: "news:list",
        },
      },
      {
        path: "news/new",
        name: "AdminNewsCreate",
        component: () => import("../views/admin/NewsEdit.vue"),
        meta: {
          adminTitle: "新建新闻",
          title: "新建新闻 - 鑫品钢结构",
          permission: "news:create",
        },
      },
      {
        path: "news/:id",
        name: "AdminNewsEdit",
        component: () => import("../views/admin/NewsEdit.vue"),
        meta: {
          adminTitle: "编辑新闻",
          title: "编辑新闻 - 鑫品钢结构",
          permission: "news:edit",
        },
      },
      {
        path: "projects",
        name: "AdminProjectList",
        component: () => import("../views/admin/ProjectList.vue"),
        meta: {
          adminTitle: "案例管理",
          title: "案例管理 - 鑫品钢结构",
          permission: "projects:list",
        },
      },
      {
        path: "projects/new",
        name: "AdminProjectCreate",
        component: () => import("../views/admin/ProjectEdit.vue"),
        meta: {
          adminTitle: "新建案例",
          title: "新建案例 - 鑫品钢结构",
          permission: "projects:create",
        },
      },
      {
        path: "projects/:id",
        name: "AdminProjectEdit",
        component: () => import("../views/admin/ProjectEdit.vue"),
        meta: {
          adminTitle: "编辑案例",
          title: "编辑案例 - 鑫品钢结构",
          permission: "projects:edit",
        },
      },
      {
        path: "jobs",
        name: "AdminJobList",
        component: () => import("../views/admin/JobList.vue"),
        meta: {
          adminTitle: "岗位管理",
          title: "岗位管理 - 鑫品钢结构",
          permission: "jobs:list",
        },
      },
      {
        path: "jobs/new",
        name: "AdminJobCreate",
        component: () => import("../views/admin/JobEdit.vue"),
        meta: {
          adminTitle: "新建岗位",
          title: "新建岗位 - 鑫品钢结构",
          permission: "jobs:create",
        },
      },
      {
        path: "jobs/:id",
        name: "AdminJobEdit",
        component: () => import("../views/admin/JobEdit.vue"),
        meta: {
          adminTitle: "编辑岗位",
          title: "编辑岗位 - 鑫品钢结构",
          permission: "jobs:edit",
        },
      },
      {
        path: "banners",
        name: "AdminBanners",
        component: () => import("../views/admin/Banners.vue"),
        meta: {
          adminTitle: "轮播配置",
          title: "轮播配置 - 鑫品钢结构",
          permission: "banners:list",
        },
      },
      {
        path: "users",
        name: "AdminUserList",
        component: () => import("../views/admin/UserList.vue"),
        meta: {
          adminTitle: "用户管理",
          title: "用户管理 - 鑫品钢结构",
          permission: "users:list",
        },
      },
      {
        path: "users/new",
        name: "AdminUserCreate",
        component: () => import("../views/admin/UserEdit.vue"),
        meta: {
          adminTitle: "新建用户",
          title: "新建用户 - 鑫品钢结构",
          permission: "users:create",
        },
      },
      {
        path: "users/:id",
        name: "AdminUserEdit",
        component: () => import("../views/admin/UserEdit.vue"),
        meta: {
          adminTitle: "编辑用户",
          title: "编辑用户 - 鑫品钢结构",
          permission: "users:edit",
        },
      },
      {
        path: "messages",
        name: "AdminMessageList",
        component: () => import("../views/admin/MessageList.vue"),
        meta: {
          adminTitle: "留言管理",
          title: "留言管理 - 鑫品钢结构",
          permission: "messages:list",
        },
      },
      {
        path: "audit-logs",
        name: "AdminAuditLogs",
        component: () => import("../views/admin/AuditLog.vue"),
        meta: {
          adminTitle: "审计日志",
          title: "审计日志 - 鑫品钢结构",
          permission: "audit-logs:view",
        },
      },
      {
        path: "visitors",
        name: "AdminVisitorList",
        component: () => import("../views/admin/VisitorList.vue"),
        meta: {
          adminTitle: "访问列表",
          title: "访问列表 - 鑫品钢结构",
          permission: "visitors:list",
        },
      },
      {
        path: "violations",
        name: "AdminViolations",
        component: () => import("../views/admin/ViolationList.vue"),
        meta: {
          adminTitle: "内容合规",
          title: "内容合规 - 鑫品钢结构",
          permission: "violations:view",
        },
      },
      {
        path: "config",
        name: "AdminSystemConfig",
        component: () => import("../views/admin/SystemConfig.vue"),
        meta: {
          adminTitle: "企业配置",
          title: "企业配置 - 鑫品钢结构",
          permission: "config:view",
        },
      },
      {
        path: "roles",
        name: "AdminRoleList",
        component: () => import("../views/admin/RoleList.vue"),
        meta: {
          adminTitle: "角色管理",
          title: "角色管理 - 鑫品钢结构",
          permission: "roles:list",
        },
      },
      {
        path: "roles/new",
        name: "AdminRoleCreate",
        component: () => import("../views/admin/RoleEdit.vue"),
        meta: {
          adminTitle: "新建角色",
          title: "新建角色 - 鑫品钢结构",
          permission: "roles:create",
        },
      },
      {
        path: "roles/:id",
        name: "AdminRoleEdit",
        component: () => import("../views/admin/RoleEdit.vue"),
        meta: {
          adminTitle: "编辑角色",
          title: "编辑角色 - 鑫品钢结构",
          permission: "roles:edit",
        },
      },
      {
        path: "menus",
        name: "AdminMenuManage",
        component: () => import("../views/admin/MenuManage.vue"),
        meta: {
          adminTitle: "菜单管理",
          title: "菜单管理 - 鑫品钢结构",
          permission: "menus:manage",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, _from, next) => {
  // Redirect logged-in users away from login page
  if (to.name === "AdminLogin" && store.state.admin.authenticated) {
    return next("/admin");
  }
  // Require auth for admin routes
  if (to.matched.some((r) => r.meta.requiresAuth)) {
    if (!store.state.admin.authenticated) {
      return next("/admin/login");
    }
    // Check route-level permission (only if user data is loaded from a post-RBAC login)
    const perm = to.meta.permission;
    if (
      perm &&
      store.state.admin.user &&
      !store.getters["admin/hasPermission"](perm)
    ) {
      // Avoid infinite redirect when dashboard is the fallback
      if (to.path !== "/admin") {
        return next("/admin");
      }
    }
  }
  next();
});

router.afterEach((to) => {
  applySEOPage(to.name || "Home", {}, store.state);
  // record public page visits for dashboard stats
  if (!to.path.startsWith("/admin")) {
    recordVisit(to.path);
  }
});

export default router;
